import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import NonAppPageShell from "./NonAppPageShell";
export default function PrivacyPage(t0) {
  const $ = _c(13);
  const {
    origin: t1,
    contactEmail: t2
  } = t0;
  const origin = t1 === undefined ? "https://catchy.nz" : t1;
  const contactEmail = t2 === undefined ? "feedback@catchy.nz" : t2;
  const t3 = `${origin}/privacy`;
  const t4 = `${origin}/share/share-privacy.png`;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="mb-4 text-3xl font-semibold">Privacy</h1>;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mb-6">Catchy is private by design. There’s no need to log in to store your favourite stops, and there is{" "}<a href="https://themarkup.org/blacklight?url=catchy.nz" className="text-blue-500">no tracking</a>{" "}of what you personally do in the app. No third-party trackers or cookies are in place at all, and none of your personal information is stored.</p>;
    t7 = <h2 className="mb-2 text-xl font-semibold">Third parties</h2>;
    $[1] = t6;
    $[2] = t7;
  } else {
    t6 = $[1];
    t7 = $[2];
  }
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="mb-4">Catchy depends on third-party services for hosting, maps, weather, and public transport data. Those services may receive technical information about requests made by your browser or app, and some may collect anonymised usage data. The current service list is maintained on the{" "}<Link href="/about" className="text-blue-500">About page</Link>.</p>;
    t9 = <p className="mb-4">If you use optional region-specific features, such as stored value card lookups where available, the provider of that feature may receive the details needed to answer your request. Catchy does not store those details or the returned private account information.</p>;
    $[3] = t8;
    $[4] = t9;
  } else {
    t8 = $[3];
    t9 = $[4];
  }
  const t10 = `mailto:${contactEmail}`;
  let t11;
  if ($[5] !== contactEmail || $[6] !== t10) {
    t11 = <p className="mb-4">If you have any questions or concerns about Catchy’s use of your data, contact{" "}<a href={t10} className="text-blue-500">{contactEmail}</a></p>;
    $[5] = contactEmail;
    $[6] = t10;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="mb-4">For the wider rules about using Catchy, read the{" "}<Link href="/terms" className="text-blue-500">Terms of use</Link>.</p>;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== t11 || $[10] !== t3 || $[11] !== t4) {
    t13 = <NonAppPageShell title={"Catchy \u2014 Privacy policy"} description="Making public transport a bit more private" canonicalUrl={t3} image={t4}>{t5}{t6}{t7}{t8}{t9}{t11}{t12}</NonAppPageShell>;
    $[9] = t11;
    $[10] = t3;
    $[11] = t4;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  return t13;
}